import PageHero from "../components/PageHero";
import CaseStudy from "../components/sections/CaseStudy";
import { CALENDLY_URL } from "../lib/site";

export default function CaseStudiesPage() {
  return (
    <div data-testid="case-studies-page">
      <PageHero
        eyebrow="Case Studies"
        accent="#00C2B8"
        title={
          <>
            Real spaces.{" "}
            <span className="bg-[#FF6600] text-white px-2 inline-block">
              Real students.
            </span>{" "}
            Real shifts.
          </>
        }
        intro="10+ years of delivery across schools, libraries and community programs — here's how the work shows up in the real world."
        ctaLabel="Book a Discovery Call"
        ctaTo={CALENDLY_URL}
        ctaExternal
      />
      <CaseStudy />
    </div>
  );
}
